import PropTypes from 'prop-types';
import React from 'react';
import SVGIconWrapper from '../../../../Icons/SVGIconWrapper/SVGIconWrapper';
import InputField from '../../../../Input/InputField/InputField';

import './SearchForm.scss';

const SearchIcon = ({ svgcssclass, gcssclass }) => (
    <svg
        className={`component-Icons-NavIcons-Search ${svgcssclass}`}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <path
            className={`${gcssclass}`}
            fill="none"
            fillRule="evenodd"
            stroke="#6A2075"
            strokeWidth="1.2"
            d="M8.55 14.59c3.337 0 6.052-2.711 6.052-6.045 0-3.333-2.715-6.045-6.051-6.045C5.214 2.5 2.5 5.212 2.5 8.545c0 3.334 2.714 6.046 6.05 6.046M8.55 2c3.613 0 6.552 2.936 6.552 6.545a6.516 6.516 0 0 1-1.75 4.448l8.575 8.567a.25.25 0 1 1-.354.354l-8.575-8.568a6.529 6.529 0 0 1-4.447 1.745C4.939 15.09 2 12.155 2 8.545 2 4.936 4.939 2 8.55 2"
        />
    </svg>
);

export default class SearchForm extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            shouldShowSearchBar: false,
            searchValue: '',
        };
    }

    static propTypes = {
        /**
         * additional styling
         */
        className: PropTypes.string,
    };

    static defaultProps = {
        className: () => {},
    };

    handleInputChange = (searchValue) => this.setState({ searchValue });

    handleIconClick = (event) => {
        const { searchValue, shouldShowSearchBar } = this.state;
        event.preventDefault();
        if (searchValue) {
            this.handleSearch();
            return;
        }

        if (!searchValue && shouldShowSearchBar) this.handleCloseForm();
        else this.setState({ shouldShowSearchBar: true });
    };

    search = (queryString) => {
        const formattedQueryString = queryString.trim().split(' ').join('+');
        window.location.href = `/search?term=${formattedQueryString}`;
    };

    handleSearch = () =>
        this.search(encodeURIComponent(this.state.searchValue));

    handleCloseForm = () =>
        this.setState({ shouldShowSearchBar: false, searchValue: '' });

    render() {
        const { shouldShowSearchBar, searchValue } = this.state;
        const { className } = this.props;
        const activeStyle = shouldShowSearchBar ? 'active' : '';

        return (
            <form
                className={`component-Layout-Header-Modules-SearchForm ${className}`}
                onSubmit={this.handleIconClick}
            >
                <button className="search-button" type="submit">
                    <SVGIconWrapper
                        handleClickSVGWrapper={this.handleIconClick}
                        gCssClass={`search-icon ${activeStyle}`}
                    >
                        <SearchIcon />
                    </SVGIconWrapper>
                </button>
                <InputField
                    name="search"
                    value={searchValue}
                    onChange={this.handleInputChange}
                    placeholder="People, employers, advice"
                    classname={`search-input ${activeStyle}`}
                />
            </form>
        );
    }
}
